import React from 'react'

import MyhouseRegisterTermsPage from './terms'
import AuthPage from './auth'
import NoticeListPage from './notice/list'
import NoticeDetailPage from './notice/detail'
import NoticeFormPage from './notice/form'
import NoticeModifyFormPage from './notice/modifyForm'
import ReviewListPage from './review/list'
import ReviewDetailPage from './review/detail'
import ReviewModifyFormPage from './review/modifyForm'
import NotifyPage from './notify'
import InsuranceFormPage from './insurance/form'
import InsuranceModifyFormPage from './insurance/modifyForm'
import MainPage from './main'
import SettingPage from './setting'
import RegisterSettingPage from './registerSetting'
import GuidePage from './guide'
import closeGuidePage from './withdrawal'
import introducePage from './introduce'

import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import MyhouseLayout from '@Pages/myhouse/layout'
import DeniedPage from '@Pages/error/denied'
import PenaltyPage from '@Pages/error/penalty'
import InsuranceClaimPage from '@Pages/myhouse/insurance/claim'

export default {
  layout: MyhouseLayout,
  routes: [
    {
      path: [
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE_DENIED}`,
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE_DENIED}/:deniedCategory`,
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE_DENIED}/:deniedCategory/:deniedType`,
      ],
      exact: true,
      component: DeniedPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_PENALTY}`],
      exact: true,
      component: PenaltyPage,
    },
    {
      path: [
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/complex/:complexNo`,
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/:myhouseNo`,
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/:myhouseNo/:categoryParam`,
        `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/:myhouseNo/:categoryParam/:typeParam`,
      ],
      exact: true,
      component: AuthPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/terms/:termsType`],
      exact: true,
      component: MyhouseRegisterTermsPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/notices`],
      exact: true,
      component: NoticeListPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/notices/:noticeSequence`],
      exact: true,
      component: NoticeDetailPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/reviews`],
      exact: true,
      component: ReviewListPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/reviews/:reviewSequence`],
      exact: true,
      component: ReviewDetailPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/board/form/notices`],
      exact: true,
      component: NoticeFormPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/board/form/reviews/:reviewSequence`],
      exact: true,
      component: ReviewModifyFormPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/:complexNo/board/form/notices/:noticeSequence`],
      exact: true,
      component: NoticeModifyFormPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/notify/settings`, `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/notify/settings/:houseNo`],
      exact: true,
      component: NotifyPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_INTRODUCE}`],
      exact: true,
      component: introducePage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/settings`],
      exact: true,
      component: SettingPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/settings`],
      exact: true,
      component: RegisterSettingPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/:houseNo/insurance/form`],
      exact: true,
      component: InsuranceFormPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/:houseNo/insurance/:insuranceSequence/form`],
      exact: true,
      component: InsuranceModifyFormPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/guide`],
      exact: true,
      component: GuidePage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/settings/withdrawal`],
      exact: true,
      component: closeGuidePage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE}`, `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/:houseNo`],
      exact: true,
      component: MainPage,
    },
    /* 무료보험 프로모션 추가부분 시작 */
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_PROMOTION_INSURANCE}/claim`],
      exact: true,
      component: InsuranceClaimPage,
    },
    /* 무료보험 프로모션 추가부분 끝 */
  ],
}
